export * from './entityTypeInfo';
export * from './funktionsbereich';
export * from './funktionsbereichKontakte';
export * from './kontakt';
export * from './kontaktAktiv';
export * from './kontaktBooleanRequest';
export * from './kontaktDataRequest';
export * from './kontaktDetail';
export * from './kontaktExtern';
export * from './kontaktIdentifier';
export * from './kontaktRequest';
export * from './kontaktTelefon';
export * from './kontaktTelefonDataRequest';
export * from './kontaktTelefonRequest';
export * from './kontaktverwaltungBenutzerZugriff';
export * from './problemDetails';
